import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IRhRepository } from "../../repositories/rh_repository";
import { BiometriaFacial } from "../../models/biometria_facial";
import { IGetBiometriaFacialUseCase } from "../../../presentation/useCases/read/get_biometria_facial_use_case";


export class GetBiometriaFacialUseCase extends BasePaginatedUseCase<BiometriaFacial> implements IGetBiometriaFacialUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getBiometriaFacial(
    idFuncionario: number,
  ): Promise<void> {
    const response = await this.repository.getBiometriaFacial(
      idFuncionario,
    );

    this._items = response.items;
    // this._currentPage = response.currentPage;
    // this._pageSize = response.pageSize;
    // this._totalItems = response.totalItems;
    // this._totalPages = response.totalPages;
  }
}